export const ADULT_VITALS = [
  { k: "hr", label: "Heart rate", unit: "bpm", low: 40, high: 130 },
  { k: "sbp", label: "Systolic BP", unit: "mmHg", low: 90, high: 180 },
  { k: "dbp", label: "Diastolic BP", unit: "mmHg", low: null, high: 120 },
  { k: "rr", label: "Resp. rate", unit: "/min", low: 8, high: 30 },
  { k: "temp", label: "Temp", unit: "°C", low: 35, high: 39.5 },
  { k: "spo2", label: "SpO₂", unit: "%", low: 92, high: null },
];

export const parseAge = (a) => { const n = parseFloat(a); return isNaN(n) ? null : n; };

export function pediatricBand(a) {
  if (a == null || a >= 18) return null;
  if (a <= 5) return { hr: [70, 160], rr: [18, 44], sbp: 74, label: "preschool (≈5y)" };
  if (a <= 12) return { hr: [60, 150], rr: [14, 40], sbp: 80, label: "child" };
  return { hr: [50, 130], rr: [9, 32], sbp: 90, label: "adolescent" };
}

export function vitalConfigForAge(a) {
  const b = pediatricBand(a);
  if (!b) return ADULT_VITALS;
  return [
    { k: "hr", label: "Heart rate", unit: "bpm", low: b.hr[0], high: b.hr[1] },
    { k: "sbp", label: "Systolic BP", unit: "mmHg", low: b.sbp, high: null },
    { k: "dbp", label: "Diastolic BP", unit: "mmHg", low: null, high: 110 },
    { k: "rr", label: "Resp. rate", unit: "/min", low: b.rr[0], high: b.rr[1] },
    { k: "temp", label: "Temp", unit: "°C", low: 35, high: 39.5 },
    { k: "spo2", label: "SpO₂", unit: "%", low: 92, high: null },
  ];
}

export const vitalAbnormal = (v, val) => {
  const n = parseFloat(val);
  if (val === "" || val == null || isNaN(n)) return false;
  if (v.low != null && n < v.low) return true;
  if (v.high != null && n > v.high) return true;
  return false;
};
